import { EquipmentForm, EquipmentMachineHourEntryForm } from '@/models'
import type { TEquipmentsState } from '@/types/state-types'

export default <TEquipmentsState>{
  equipmentForm: new EquipmentForm(),
  isEquipmentLoading: false,
  equipmentsMachineHourEntryForm: new EquipmentMachineHourEntryForm()
}
